import ForgotPin from '../views/ForgotPin.vue'

export default {
  component: ForgotPin,
  meta: {
    back: 'login',
    showMenu: false,
  },
  name: 'forgotPin',
  path: '/forgot-pin',
}
